import { AxiosResponse } from "axios";
import { Result } from "@/main/models/common/resultResponse";
import { TemplateEmailNotificationVariableResponse } from "@/main/models/response/templateEmailNotificationResponse";

export interface GetVariablesRequest {
	idTemplateEmailNotification: number;
}

export abstract class ITemplateEmailNotificationVariableApi {
	abstract getVariables(
		request: GetVariablesRequest,
	): Promise<AxiosResponse<Result<TemplateEmailNotificationVariableResponse[]>>>;
}
